import { useState, type FormEvent } from 'react'
import { Reveal } from '../components/Reveal'
import { Kicker } from '../components/Kicker'
import { FluidHeading } from '../components/FluidHeading'
import { CONTACT_EMAIL } from '../lib/contactInfo'

const NEEDS = [
  'Tráfego Pago',
  'Site / Landing Page',
  'Social Media',
  'Identidade Visual',
  'Design / Criativos',
  'Ainda não sei',
]

export function Contact() {
  const [name, setName] = useState('')
  const [company, setCompany] = useState('')
  const [whatsapp, setWhatsapp] = useState('')
  const [need, setNeed] = useState('')
  const [sent, setSent] = useState(false)

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    const subject = encodeURIComponent(`Novo contato — ${name}`)
    const body = encodeURIComponent(
      `Nome: ${name}\nEmpresa: ${company}\nWhatsApp: ${whatsapp}\nO que busca: ${need}`,
    )
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`
    setSent(true)
  }

  return (
    <section id="contato" className="relative mx-auto max-w-4xl px-5 py-24 sm:px-8 sm:py-32">
      <Reveal>
        <div className="mx-auto flex max-w-xl flex-col items-center text-center">
          <Kicker>Contato</Kicker>
          <FluidHeading as="h2" className="text-3xl font-semibold text-white sm:text-5xl">
            Vamos <span className="text-gradient">falar de resultado?</span>
          </FluidHeading>
          <p className="mt-4 text-white/55">
            Conte um pouco sobre seu negócio e o que você busca. Nosso time entra em contato para
            entender o cenário e identificar como podemos ajudar.
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <form onSubmit={handleSubmit} className="glass-card mt-12 rounded-3xl p-6 sm:p-10">
          <div className="grid gap-5 sm:grid-cols-2 sm:gap-6">
            <div className="flex flex-col gap-2 text-left">
              <label htmlFor="contact-name" className="text-xs font-medium uppercase tracking-wider text-white/50">
                Nome
              </label>
              <input
                id="contact-name"
                name="name"
                autoComplete="name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Seu nome"
                className="rounded-xl border border-white/10 bg-white/5 px-4 py-3.5 text-sm text-white placeholder:text-white/30 outline-none transition-colors focus:border-orb-400/60 focus:ring-2 focus:ring-orb-400/20"
              />
            </div>
            <div className="flex flex-col gap-2 text-left">
              <label htmlFor="contact-company" className="text-xs font-medium uppercase tracking-wider text-white/50">
                Empresa
              </label>
              <input
                id="contact-company"
                name="organization"
                autoComplete="organization"
                required
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                placeholder="Nome da sua empresa"
                className="rounded-xl border border-white/10 bg-white/5 px-4 py-3.5 text-sm text-white placeholder:text-white/30 outline-none transition-colors focus:border-orb-400/60 focus:ring-2 focus:ring-orb-400/20"
              />
            </div>
          </div>

          <div className="mt-5 grid gap-5 sm:grid-cols-2 sm:gap-6">
            <div className="flex flex-col gap-2 text-left">
              <label htmlFor="contact-whatsapp" className="text-xs font-medium uppercase tracking-wider text-white/50">
                WhatsApp
              </label>
              <input
                id="contact-whatsapp"
                name="tel"
                type="tel"
                inputMode="tel"
                autoComplete="tel"
                required
                value={whatsapp}
                onChange={(e) => setWhatsapp(e.target.value)}
                placeholder="(11) 90000-0000"
                className="rounded-xl border border-white/10 bg-white/5 px-4 py-3.5 text-sm text-white placeholder:text-white/30 outline-none transition-colors focus:border-orb-400/60 focus:ring-2 focus:ring-orb-400/20"
              />
            </div>
            <div className="flex flex-col gap-2 text-left">
              <label htmlFor="contact-need" className="text-xs font-medium uppercase tracking-wider text-white/50">
                O que você busca?
              </label>
              <div className="relative">
                <select
                  id="contact-need"
                  name="need"
                  required
                  value={need}
                  onChange={(e) => setNeed(e.target.value)}
                  className="w-full appearance-none rounded-xl border border-white/10 bg-white/5 px-4 py-3.5 pr-10 text-sm text-white outline-none transition-colors focus:border-orb-400/60 focus:ring-2 focus:ring-orb-400/20 [&>option]:bg-space-900"
                >
                  <option value="" disabled>
                    Selecione uma opção
                  </option>
                  {NEEDS.map((n) => (
                    <option key={n} value={n}>
                      {n}
                    </option>
                  ))}
                </select>
                <svg
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                  className="pointer-events-none absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-white/40"
                >
                  <path
                    d="M6 9l6 6 6-6"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="mt-8 w-full rounded-full bg-gradient-to-r from-orb-400 to-orb-700 px-8 py-3.5 text-sm font-semibold text-white shadow-[0_0_35px_-8px_rgba(139,60,240,1)] transition-transform hover:scale-[1.02] sm:w-auto"
          >
            Enviar mensagem
          </button>

          {sent && (
            <p className="mt-4 text-sm text-orb-200">
              Abrindo seu cliente de e-mail — se nada acontecer, escreva para {CONTACT_EMAIL}.
            </p>
          )}
        </form>
      </Reveal>
    </section>
  )
}
